module.exports = __webpack_public_path__ + "static/media/nexus.d382f37f.png";